enum ParticleState {
    SCALING_UP,
    SCALING_DOWN,
    DEAD
}

export class SparkleParticle extends Phaser.GameObjects.Particles.Particle
{
    public static MAX_SCALE: number = 1;
    public static SCALE_STEP: number = 0.03;

    private ROTATION_AMP:number = 4;
    private customRotation: number;
    private state:ParticleState = ParticleState.SCALING_UP;

    constructor (emitter)
    {
        super(emitter);

        this.customRotation = 0.5 * this.ROTATION_AMP - Math.random() * this.ROTATION_AMP;
    }

    /**
     * Reset (this particle is being reused from pool)
     * 
     * 3.60: The Particle.resetPosition method has been renamed to setPosition and it now takes optional x/y parameters. If not given, it performs the same task as resetPosition did in earlier versions.
     */
    public override setPosition(): void
    {
        this.scaleX = this.scaleY = 0;
        this.state = ParticleState.SCALING_UP;
    }

    public override update (delta: number, step: number, processors: any[]): boolean
    {
        var result = super.update(delta, step, processors);
        let scale: number = 0;

        this.angle += this.customRotation;

        if (this.state == ParticleState.SCALING_UP) {
            scale = this.scaleX + SparkleParticle.SCALE_STEP;
            this.scaleX = scale;
            this.scaleY = scale;
            if (scale > SparkleParticle.MAX_SCALE) {
                this.state = ParticleState.SCALING_DOWN;
            } 
        }
        else
        if (this.state == ParticleState.SCALING_DOWN) {
            scale = this.scaleX - SparkleParticle.SCALE_STEP;
            this.scaleX = scale;
            this.scaleY = scale;
            if (scale <= 0) {
                this.scaleX = 0;
                this.scaleY = 0;
                this.state = ParticleState.DEAD;
            } 
        }
        // this.scaleX = this.scaleY = this.scaleX + 1;

        return result;
    }
}